import { createContext } from 'react';
export var globalContextDefaultValue = {
    loading: false,
    setLoading: function () { return undefined; },
    loadingText: null,
    setLoadingText: function () { return undefined; },
};
export var GlobalContext = createContext(globalContextDefaultValue);
